import { render, staticRenderFns } from "./CourseGroupSubsection.vue?vue&type=template&id=3aeadb2b&scoped=true"
import script from "./CourseGroupSubsection.vue?vue&type=script&lang=js"
export * from "./CourseGroupSubsection.vue?vue&type=script&lang=js"
import style0 from "./CourseGroupSubsection.vue?vue&type=style&index=0&id=3aeadb2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeadb2b",
  null
  
)

export default component.exports